<template>
    <svg
        version="1.1"
        id="图层_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1280 720"
        style="enable-background:new 0 0 1280 720;"
        xml:space="preserve"
    >
        <circle class="st0" cx="437.2" cy="360" r="107.2" />
        <g>
            <g id="snakeball_00000154412184457504243440000000722208250675200952_">
                <g>
                    <defs>
                        <circle id="SVGID_1_" cx="784.9" cy="521.8" r="120.6" />
                    </defs>
                    <clipPath id="SVGID_00000070805632074724540150000016972647168016195519_">
                        <use xlink:href="#SVGID_1_" style="overflow:visible;" />
                    </clipPath>

                    <g
                        id="snakeball_00000077302939392205197550000004415577628854971785_"
                        style="clip-path:url(#SVGID_00000070805632074724540150000016972647168016195519_);"
                    >
                        <g>
                            <circle class="st2" cx="761.6" cy="579.1" r="14" />
                            <circle class="st2" cx="764.6" cy="538.7" r="14" />
                            <circle class="st2" cx="777.2" cy="501.7" r="14" />
                            <circle class="st2" cx="798.2" cy="470.1" r="14" />
                            <circle class="st2" cx="826.6" cy="446" r="14" />
                            <circle class="st2" cx="860.5" cy="431.5" r="14" />
                            <circle class="st2" cx="896.9" cy="427.2" r="14" />
                            <circle class="st2" cx="934" cy="432.9" r="14" />
                            <circle class="st2" cx="969.4" cy="448" r="14" />
                            <circle class="st2" cx="1001" cy="472.3" r="14" />
                            <circle class="st2" cx="1026.7" cy="505.4" r="14" />
                        </g>
                        <circle class="st2" cx="770" cy="638.1" r="28" />
                    </g>
                </g>
            </g>
            <circle class="st0" cx="728.2" cy="483.1" r="20.9" />
            <circle class="st3" cx="784.9" cy="521.8" r="120.6" />
            <polyline class="st4" points="874.7,509.6 896.4,537.8 950,483.1 	" />
        </g>
        <g>
            <g id="snakeball">
                <g>
                    <defs>
                        <circle id="SVGID_00000083079214301625512890000016108624706566726839_" cx="784.9" cy="198.2" r="120.6" />
                    </defs>
                    <clipPath id="SVGID_00000141429504130584813250000010003285123128318867_">
                        <use xlink:href="#SVGID_00000083079214301625512890000016108624706566726839_" style="overflow:visible;" />
                    </clipPath>

                    <g
                        id="snakeball_00000088813371456040501580000004925738466730304133_"
                        style="clip-path:url(#SVGID_00000141429504130584813250000010003285123128318867_);"
                    >
                        <g>
                            <circle class="st2" cx="833.5" cy="225.6" r="14" />
                            <circle class="st2" cx="864.6" cy="251.7" r="14" />
                            <circle class="st2" cx="887.3" cy="283.5" r="14" />
                            <circle class="st2" cx="900.6" cy="319" r="14" />
                            <circle class="st2" cx="903.6" cy="356.1" r="14" />
                            <circle class="st2" cx="895.7" cy="392.1" r="14" />
                            <circle class="st2" cx="877.8" cy="424.2" r="14" />
                            <circle class="st2" cx="851.6" cy="451" r="14" />
                            <circle class="st2" cx="818.7" cy="470.9" r="14" />
                            <circle class="st2" cx="780.5" cy="482.4" r="14" />
                            <circle class="st2" cx="738.6" cy="484" r="14" />
                        </g>
                        <circle class="st2" cx="780.7" cy="198.1" r="28" />
                    </g>
                </g>
            </g>
            <circle class="st0" cx="728.2" cy="159.6" r="20.9" />
            <circle class="st3" cx="784.9" cy="198.2" r="120.6" />
            <g>
                <line class="st6" x1="874.7" y1="147.9" x2="926.2" y2="196.6" />
                <line class="st6" x1="926.2" y1="138.7" x2="874.7" y2="196.3" />
            </g>
        </g>
    </svg>
</template>
     
<style scoped>
.st0 {
    fill: #dc1130;
}
.st1 {
    clip-path: url(#SVGID_00000034071498579116674810000007284013514052828083_);
}
.st2 {
    fill: var(--color_back);
}
.st3 {
    fill: none;
    stroke: #8b8b8b;
    stroke-width: 9.6;
    stroke-miterlimit: 10;
}
.st4 {
    fill: none;
    stroke: #0ee515;
    stroke-width: 27.7335;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
}
.st5 {
    clip-path: url(#SVGID_00000017497026632941657420000006194532905443697319_);
}
.st6 {
    fill: none;
    stroke: #dc1130;
    stroke-width: 22.177;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
}
</style>
